/*
 * Purpose: Routes accessible without authentication
 * Last modified: 2026-06-28 | Agent
 * Completeness: 92
 */
const PUBLIC_PREFIXES = ['/', '/auth', '/help', '/pricing', '/oauth', '/status'];

export function isAuthPublicPath(pathname: string): boolean {
  if (!pathname) return true;
  if (pathname === '/') return true;
  return PUBLIC_PREFIXES.some(
    (prefix) => prefix !== '/' && (pathname === prefix || pathname.startsWith(`${prefix}/`))
  );
}
